export class ErrorMessage {

   public uiMessage: string;                 // localized message

   constructor(
      public code: string,
      public message: string = '',           // original message (englisch)
      public module: string = 'UNDEFINED',
      public errorObject: any | null = null
   ) { }

}



// WEBPACK FOOTER //
// /builds/cp/frap/t3/planer/src/app/core/model/error-message.ts